import { useEffect, useState } from 'react';
import moment from 'moment';

const TICK_MS = 30_000;
const JUST_NOW_THRESHOLD_MS = 60_000;

export function computeRelative(ts: number, now: number): string {
    if (now - ts < JUST_NOW_THRESHOLD_MS) return 'just now';
    return moment(ts).from(moment(now));
}

/**
 * Returns a relative-time label for `ts` that re-renders every 30s while
 * `enabled` is true. Cleanup releases the interval on unmount or when the
 * modal closes. The interval is gated on `enabled` to avoid running while
 * the modal is closed.
 */
export function useGeneratedLabel(ts: number, enabled: boolean): string {
    const [now, setNow] = useState<number>(() => Date.now());

    useEffect(() => {
        if (!enabled) return undefined;
        const id = setInterval(() => setNow(Date.now()), TICK_MS);
        return () => clearInterval(id);
    }, [enabled]);

    // Recompute label on every render so changes in `ts` (refresh) update immediately
    return computeRelative(ts, now);
}
